// src/components/MiniSparkline.jsx
import React from "react";
import { Line, LineChart, ResponsiveContainer } from "recharts";

const MiniSparkline = ({ trend = "up", value = 0 }) => {
  // Generate mock 7-day data based on current value and trend
  const generateData = () => {
    const data = [];
    const baseValue = 100;
    const volatility = Math.abs(value) / 100 || 5;
    
    for (let i = 0; i < 7; i++) {
      const random = (Math.random() - 0.5) * volatility;
      const trendEffect = trend === "up" ? (i * volatility / 7) : -(i * volatility / 7);
      data.push({
        value: baseValue + trendEffect + random
      });
    }
    return data;
  };

  const data = generateData();
  const color = value >= 0 ? "#10B981" : "#EF4444"; // green or red

  return (
    <ResponsiveContainer width={60} height={24}>
      <LineChart data={data}>
        <Line
          type="monotone"
          dataKey="value"
          stroke={color}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default MiniSparkline;
